require("!!/home/jormat/jormat-front/node_modules/script-loader/addScript.js")(require("!!/home/jormat/jormat-front/node_modules/raw-loader/index.js!/home/jormat/jormat-front/bower_components/select2/select2.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/select2/select2.js
// module id = 542
// module chunks = 0